module.exports = __webpack_public_path__ + "static/media/loanPayment_Selected.25e829dd.svg";